import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import MyAccountCard from "@routes/MyAccount/components/MyAccountCard";
import { MyAccountReadingHistoryPopoverProps } from "@routes/MyAccount/utils/types";

/**
 * MyAccount Recent Read List Component
 * Figma: https://www.figma.com/design/soi1ZhMqZHbss6tJLvLgaa/MY-ACCOUNT--WEB-?node-id=3611-23095&t=XsTPoO6b0V5zVeJ1-4
 */
const MyAccountReadingHistoryPopoverList = ({
  articleList,
  isDisplayViewMore,
}: MyAccountReadingHistoryPopoverProps): React.ReactElement => {
  const handleSessionStorage = () => {
    sessionStorage.setItem("account-reading-history", "true");
  };

  return (
    <div data-testid="my-account-reading-history-popover-list-component">
      <div>
        {articleList.map((article) => {
          return (
            <MyAccountCard key={article.id.toString()} article={article} />
          );
        })}
      </div>

      {isDisplayViewMore ? (
        <Link
          to={RouteFactory.myAccount}
          onClick={handleSessionStorage}
          reloadDocument
          className="mx-auto mt-4 flex w-max justify-center rounded-[50px] border border-gray-175 px-6 py-4 text-center font-poppins text-xs font-semibold text-gray-850"
        >
          View More
        </Link>
      ) : null}
    </div>
  );
};

export default MyAccountReadingHistoryPopoverList;
